import { View } from 'react-native';
import { clsx } from 'clsx';
import { BrowserWindow, ImageTile, TextLine } from './illustration-interface';
import { IllustrationScene } from './illustration-scene';
import { illustrationPalette, illustrationImagePalettes } from './illustration-palette';
import {
  ProfileAvatar,
  ProfileName,
  ProfileAnimalCard,
  ProfilePhone,
} from './breeder-profile/parts';

export function BreederProfile({ transparent = false }: { transparent?: boolean }) {
  return (
    <View
      testID="breeder-profile-illustration"
      className={clsx('aspect-square w-full overflow-hidden', !transparent && 'rounded-2xl')}
      style={{ backgroundColor: transparent ? undefined : illustrationPalette.sageLight }}
    >
      <IllustrationScene transparent>
        {(s) => (
          <>
            <BrowserWindow s={s} left={7} top={24} width={120} height={112} addressAlign="left">
              <View testID="breeder-web-profile" style={{ padding: s(5), gap: s(3.5) }}>
                <ImageTile
                  s={s}
                  width={105}
                  height={20}
                  motif="mountain"
                  colors={illustrationImagePalettes.forest}
                />
                <View className="flex-row items-center" style={{ width: s(74), gap: s(4) }}>
                  <ProfileAvatar s={s} size={13} />
                  <ProfileName s={s} />
                </View>
                <View testID="breeder-web-description" style={{ gap: s(2.5) }}>
                  <TextLine s={s} width={72} height={1.5} className="bg-brand-brown-dark/30" />
                  <TextLine
                    s={s}
                    width={72 * 0.88}
                    height={1.5}
                    className="bg-brand-brown-dark/25"
                  />
                  <TextLine
                    s={s}
                    width={72 * 0.7}
                    height={1.5}
                    className="bg-brand-brown-dark/15"
                  />
                </View>
                <View className="flex-row" style={{ gap: s(5) }}>
                  <ProfileAnimalCard s={s} width={33} height={30} pet="first" />
                  <ProfileAnimalCard s={s} width={33} height={30} pet="second" />
                </View>
              </View>
            </BrowserWindow>
            <View
              pointerEvents="none"
              className="absolute"
              style={{ left: s(92), top: s(20), zIndex: 20, transform: [{ rotate: '3deg' }] }}
            >
              <ProfilePhone s={(value) => s(value * 0.98)} />
            </View>
          </>
        )}
      </IllustrationScene>
    </View>
  );
}
